import { __commonJSMin as e } from "../../../../../../../../../_virtual/_rolldown/runtime.js";
import { require_html_block as t } from "./html-block.js";
import { require_email_template as n } from "./email-template.js";
import { require_default as r } from "./default.js";
import { require_inbox_composer as i } from "./inbox-composer.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0/node_modules/@intercom/intercom-sanitizer/dist/html/config/index.js
var a = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = u;
	var a = n(), o = r(), s = i(), c = t(), l = {
		default: o.DEFAULT_CONFIG,
		email: a.EMAIL_TEMPLATE_CONFIG,
		inboxComposer: s.INBOX_COMPOSER_CONFIG,
		htmlBlock: c.HTML_BLOCK_CONFIG
	};
	function u() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
		if (!l[e]) throw Error(`@intercom/intercom-sanitizer: You passed an invalid configuration, \`${e}\`,  to \`sanitizeHtml\`. The only valid configurations are: \`${Object.keys(l).join(", ")}\``);
		return l[e];
	}
}));
//#endregion
export default a();
export { a as require_config };
